<template>
  <v-container grid-list-xs>
    <v-card>
      <v-card-title>Lojas</v-card-title>
      <v-card-text v-if="!canListStores">Selecione um Grupo</v-card-text>
      <template v-else>
        <v-alert
          v-if="isPlatformAdmin && !groupSelected"
          type="info"
          variant="tonal"
          density="compact"
          class="ma-3"
        >
          Listagem global (somente leitura). Selecione um grupo para criar ou editar lojas.
        </v-alert>
        <v-row>
          <v-col cols="12">
            <v-form :submit="submitSearch">
              <v-expansion-panels variant="accordion" v-model="filterPanel">
                <v-expansion-panel value="searchFiltersPanel" rounded="lg">
                  <v-expansion-panel-title
                    style="color:#000000 !important; background-color: #e0e0e0ff; opacity: 1 !important"
                  >
                    <v-row style="opacity: 1 !important">
                      <v-col cols="3">
                        <span class="v-card-title">Filtro de pesquisa</span>
                      </v-col>
                      <v-col cols="9" class="pe-10">
                        <DialogCreateUpdateStore
                          v-if="canMutate"
                          :user="user"
                          v-model="editStoreModel"
                          :floatRight="true"
                          @created="createdStore"
                          @updated="updatedStore"
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-title>
                  <v-expansion-panel-text class="bg-grey-lighten-2">
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-model="filters.searchText"
                          label="Nome"
                          clearable
                          density="compact"
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-select
                          v-model="filters.status"
                          :items="statusFilterItems"
                          item-title="title"
                          item-value="value"
                          label="Status"
                          clearable
                          density="compact"
                          hide-details
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-select
                          v-model="filters.type"
                          :items="typeFilterItems"
                          item-title="title"
                          item-value="value"
                          label="Tipo"
                          clearable
                          density="compact"
                          hide-details
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-select
                          :items="[50, 100, 200]"
                          v-model="filters.itemsPerPage"
                          label="Resultados por página"
                          density="compact"
                          hide-details
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-card-actions>
                      <v-btn color="warning" @click="clearFilters()">
                        <v-icon class="mr-2">mdi-broom</v-icon>
                        Limpar pesquisa
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" type="submit" :loading="requestingApi">
                        <v-icon class="mr-2">mdi-magnify</v-icon>
                        Pesquisar
                      </v-btn>
                    </v-card-actions>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-form>
          </v-col>
          <v-col cols="12">
            <v-card>
              <v-data-table
                :headers="tableHeaders"
                :items="lstObjects"
                :items-per-page="filters.itemsPerPage"
                return-object
                class="elevation-1"
                hide-default-footer
              >
                <template v-slot:bottom>
                  <div class="text-center pt-2">
                    <v-pagination
                      :disabled="requestingApi"
                      v-model="page"
                      :length="maxPage"
                    ></v-pagination>
                  </div>
                </template>
                <template v-slot:item.group_name="{ item }">
                  <span>{{ item?.group?.name || '—' }}</span>
                </template>
                <template v-slot:item.type="{ value }">
                  <span>{{ typeLabel(value) }}</span>
                </template>
                <template v-slot:item.status="{ value }">
                  <span>{{ statusLabel(value) }}</span>
                </template>
                <template v-slot:item.payments="{ item }">
                  <div class="d-flex flex-wrap ga-1 py-1">
                    <v-chip
                      v-if="item?.pix_enabled"
                      size="x-small"
                      color="primary"
                      variant="tonal"
                    >
                      Pix
                    </v-chip>
                    <v-chip
                      v-if="item?.tap_enabled"
                      size="x-small"
                      color="secondary"
                      variant="tonal"
                    >
                      TAP
                    </v-chip>
                    <v-chip
                      v-if="item?.invoice_enabled"
                      size="x-small"
                      color="info"
                      variant="tonal"
                    >
                      Cobrança
                    </v-chip>
                    <span
                      v-if="!item?.pix_enabled && !item?.tap_enabled && !item?.invoice_enabled"
                      class="text-medium-emphasis"
                    >
                      —
                    </span>
                  </div>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-menu>
                    <template v-slot:activator="{ props }">
                      <v-btn icon variant="text" v-bind="props">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-if="canMutate"
                        @click="editStoreModel = { ...item }"
                      >
                        <v-list-item-title>
                          <v-icon color="primary" class="mr-2">mdi-pencil</v-icon>
                          Editar
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="openStore(item)">
                        <v-list-item-title>
                          <v-icon color="secondary" class="mr-2">mdi-open-in-app</v-icon>
                          Abrir
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-card>
  </v-container>
</template>
<script>
import DialogCreateUpdateStore from '../components/DialogCreateUpdateStore.vue'
import api from '@/services'
import { normalizeListPayload } from '@/utils/listPayload'

const STORE_TYPES = [
  { title: 'Normal', value: 'normal' },
  { title: 'Perecíveis', value: 'pereciveis' },
  { title: 'Ingressos', value: 'ingressos' },
]
const STORE_STATUSES = [
  { title: 'Ativa', value: 'active' },
  { title: 'Inativa', value: 'inactive' },
]

export default {
  components: { DialogCreateUpdateStore },
  props: {
    user: Object,
  },
  data() {
    return {
      requestingApi: false,
      baseHeaders: [
        { title: 'Nome', align: 'start', key: 'name', sortable: true },
        { title: 'Tipo', align: 'start', key: 'type', sortable: true },
        { title: 'Status', align: 'start', key: 'status', sortable: true },
        { title: 'Pagamentos', align: 'start', key: 'payments', sortable: false },
        { title: 'Ações', key: 'actions', align: 'end', sortable: false },
      ],
      lstObjects: [],
      filters: {
        searchText: null,
        status: null,
        type: null,
        itemsPerPage: 50,
      },
      page: 1,
      maxPage: 1,
      filterPanel: 'searchFiltersPanel',
      editStoreModel: {},
      statusFilterItems: [
        { title: 'Todas', value: null },
        ...STORE_STATUSES,
      ],
      typeFilterItems: [
        { title: 'Todos', value: null },
        ...STORE_TYPES,
      ],
    }
  },
  created() {
    const vm = this
    const saved = localStorage['_stores_itemsPerPage']
    if (saved) {
      vm.filters.itemsPerPage = parseInt(saved, 10) || 50
    }
  },
  activated() {
    if (this.canListStores) {
      this.fetchList(this.page)
    }
  },
  mounted() {
    if (this.canListStores) {
      this.fetchList(1)
    }
  },
  methods: {
    typeLabel(value) {
      const legacy = { permanent: 'Normal', stall: 'Perecíveis', event: 'Ingressos' }
      const found = STORE_TYPES.find((t) => t.value === value)
      return found ? found.title : (legacy[value] || value)
    },
    statusLabel(value) {
      const found = STORE_STATUSES.find((s) => s.value === value)
      return found ? found.title : value
    },
    clearFilters() {
      const vm = this
      vm.filters.searchText = null
      vm.filters.status = null
      vm.filters.type = null
    },
    submitSearch(e) {
      if (e?.preventDefault) e.preventDefault()
      this.fetchList(1)
    },
    fetchList(page) {
      const vm = this
      if (!vm.canListStores || vm.requestingApi) return
      vm.requestingApi = true
      vm.page = page || 1
      const payload = {
        searchText: vm.filters.searchText || undefined,
        status: vm.filters.status || undefined,
        type: vm.filters.type || undefined,
        itemsPerPage: vm.filters.itemsPerPage,
      }
      // Cross-group list: API eager-loads group; withGroup also ok when scoped
      if (vm.isPlatformAdmin && !vm.groupSelected) {
        payload.withGroup = true
      }
      return api.store
        .list(payload, vm.page)
        .then((result) => {
          const { items, meta } = normalizeListPayload(result)
          vm.lstObjects = items
          if (meta) {
            vm.page = meta.current_page || vm.page
            vm.maxPage = meta.last_page || 1
          } else {
            vm.maxPage = 1
          }
          vm.filterPanel = ''
        })
        .catch((err) => {
          if (err?.message) {
            vm.$notify({ type: 'warn', text: err.message })
          }
        })
        .finally(() => {
          vm.requestingApi = false
        })
    },
    createdStore(val) {
      const vm = this
      vm.editStoreModel = {}
      if (val) {
        vm.lstObjects = [val, ...vm.lstObjects]
      } else {
        vm.fetchList(vm.page)
      }
    },
    updatedStore(val) {
      const vm = this
      vm.editStoreModel = {}
      if (val?.id) {
        vm.lstObjects = vm.lstObjects.map((o) => (o.id === val.id ? val : o))
      } else {
        vm.fetchList(vm.page)
      }
    },
    openStore(item) {
      if (!item?.id) return
      this.$router.push({ name: 'StoreDetail', params: { id: item.id } })
    },
  },
  computed: {
    groupSelected() {
      return api.storage.isGroupSelected()
    },
    isPlatformAdmin() {
      return (
        this.user?.access_level >= this.$USER_ACCESS_LEVELS_DIC.ADMIN.value
      )
    },
    /** List when group selected, or platform admin global list */
    canListStores() {
      return this.groupSelected || this.isPlatformAdmin
    },
    /** Create/edit require selected group (BE 403 otherwise) */
    canMutate() {
      return this.groupSelected
    },
    tableHeaders() {
      if (this.isPlatformAdmin && !this.groupSelected) {
        return [
          { title: 'Nome', align: 'start', key: 'name', sortable: true },
          { title: 'Grupo', align: 'start', key: 'group_name', sortable: false },
          { title: 'Tipo', align: 'start', key: 'type', sortable: true },
          { title: 'Status', align: 'start', key: 'status', sortable: true },
          { title: 'Ações', key: 'actions', align: 'end', sortable: false },
        ]
      }
      return this.baseHeaders
    },
  },
  watch: {
    'filters.itemsPerPage'(newVal) {
      localStorage['_stores_itemsPerPage'] = newVal
    },
    page(newVal, oldVal) {
      if (!isNaN(newVal) && newVal !== oldVal && !this.requestingApi) {
        this.fetchList(newVal)
      }
    },
  },
}
</script>
